import { ERequestFormField } from '../../types/requestFormSchema';

const REQUEST_FORM_FIELDS = Object.values(ERequestFormField);

/* oxlint-disable typescript/no-explicit-any */
export function isRequestFormFields(field: any): field is ERequestFormField {
  return REQUEST_FORM_FIELDS.includes(field);
}
